import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import PermittedRoute from './components/PermittedRoute';
import AdminLayout from './components/layout/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StoresPage from './pages/StoresPage';
import StoreDetailPage from './pages/StoreDetailPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PaymentsPage from './pages/PaymentsPage';
import DriversPage from './pages/DriversPage';
import RequestsPage from './pages/RequestsPage';
import UsersPage from './pages/UsersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import OrdersPage from './pages/OrdersPage';
import CartsPage from './pages/CartsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import ActivityLogPage from './pages/ActivityLogPage';
import SettingsPage from './pages/SettingsPage';
import DeliverySettingsPage from './pages/DeliverySettingsPage';
import DeliveryRatingsPage from './pages/DeliveryRatingsPage';
import PromotionsPage from './pages/PromotionsPage';
import MessagesPage from './pages/MessagesPage';
import SellerSmsPage from './pages/SellerSmsPage';
import PayoutsPage from './pages/PayoutsPage';
import FinancePage from './pages/FinancePage';
import EscrowPage from './pages/EscrowPage';
import BlockedPayoutsPage from './pages/BlockedPayoutsPage';
import DeliveryClaimsPage from './pages/DeliveryClaimsPage';
import AppVersionPage from './pages/AppVersionPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/dashboard"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<PermittedRoute section="dashboard"><DashboardPage /></PermittedRoute>} />
            <Route path="users" element={<PermittedRoute section="users"><UsersPage /></PermittedRoute>} />
            <Route path="stores" element={<PermittedRoute section="stores"><StoresPage /></PermittedRoute>} />
            <Route path="stores/:storeId" element={<PermittedRoute section="stores"><StoreDetailPage /></PermittedRoute>} />
            <Route path="products" element={<PermittedRoute section="products"><ProductsPage /></PermittedRoute>} />
            <Route path="products/:productId" element={<PermittedRoute section="products"><ProductDetailPage /></PermittedRoute>} />
            <Route path="orders" element={<PermittedRoute section="orders"><OrdersPage /></PermittedRoute>} />
            <Route path="drivers" element={<PermittedRoute section="drivers"><DriversPage /></PermittedRoute>} />
            <Route path="requests" element={<PermittedRoute section="requests"><RequestsPage /></PermittedRoute>} />
            <Route path="carts" element={<PermittedRoute section="carts"><CartsPage /></PermittedRoute>} />
            <Route path="payments" element={<PermittedRoute section="payments"><PaymentsPage /></PermittedRoute>} />
            <Route path="messages" element={<PermittedRoute section="messages"><MessagesPage /></PermittedRoute>} />
            <Route path="analytics" element={<PermittedRoute section="analytics"><AnalyticsPage /></PermittedRoute>} />
            <Route path="admin-users" element={<PermittedRoute section="adminUsers"><AdminUsersPage /></PermittedRoute>} />
            <Route path="activity" element={<PermittedRoute section="activity"><ActivityLogPage /></PermittedRoute>} />
            <Route path="delivery-settings" element={<PermittedRoute section="deliverySettings"><DeliverySettingsPage /></PermittedRoute>} />
            <Route path="delivery-ratings" element={<PermittedRoute section="deliveryRatings"><DeliveryRatingsPage /></PermittedRoute>} />
            <Route path="promotions" element={<PermittedRoute section="promotions"><PromotionsPage /></PermittedRoute>} />
            <Route path="seller-sms" element={<PermittedRoute section="sellerSms"><SellerSmsPage /></PermittedRoute>} />
            <Route path="payouts" element={<PermittedRoute section="payouts"><PayoutsPage /></PermittedRoute>} />
            <Route path="finance" element={<PermittedRoute section="finance"><FinancePage /></PermittedRoute>} />
            <Route path="escrow" element={<PermittedRoute section="escrow"><EscrowPage /></PermittedRoute>} />
            <Route path="blocked-payouts" element={<PermittedRoute section="blockedPayouts"><BlockedPayoutsPage /></PermittedRoute>} />
            <Route path="delivery-claims" element={<PermittedRoute section="deliveryClaims"><DeliveryClaimsPage /></PermittedRoute>} />
            <Route path="settings"     element={<PermittedRoute section="settings"><SettingsPage /></PermittedRoute>} />
            <Route path="app-version" element={<PermittedRoute section="appVersion"><AppVersionPage /></PermittedRoute>} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
